<template>
  <div
    class="m-banner"
    :style="{
      display: extraItem.extras('banner.display') == 1 ? 'block' : 'none'
    }"
  >
    <img
      :src="
        extraItem.extras('banner.src') ? extraItem.extras('banner.src') : ''
      "
      alt=""
    />
  </div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
import { browerType } from "../common/sbase";
export default {
  name: "Banner",
  data() {
    return {
      extras: {},
      browerType: browerType
    };
  },
  created() {
    $subscriber.subscribe("config-loaded", res => {
      this.extras = res;
    });
  },
  methods: {
    //    openUrl() {
    //      if(this.bannerHref && (this.bannerHref.indexOf('http://') == 0 || this.bannerHref.indexOf('https://') == 0)){
    //        window.open(this.bannerHref);
    //      }
    //    }
  },
  components: {}
};
</script>
